import { fetchFromOldApi } from '~/services/Http';
import { getFormattedDateString } from '~/utils/helpers/date';

export type DecisionRegistryForm = {
  type: string;
  title: string;
  maker: string;
  info: string;
  reminderDate?: Date | null;
  isSystemGenerated: boolean;
  file?: File | null;
};

export const getDecisionRegistryEntryFormData = (
  data: DecisionRegistryForm,
): FormData => {
  const { type, title, maker, info, reminderDate, isSystemGenerated, file } =
    data;

  const formData = new FormData();
  formData.append('type', type);
  formData.append('title', title);
  formData.append('maker', maker);
  formData.append('info', info);
  if (!!reminderDate) {
    formData.append(
      'reminderDate',
      getFormattedDateString(reminderDate, 'YYYY-MM-DD'),
    );
  }
  formData.append('isSystemGenerated', isSystemGenerated ? 'true' : 'false');
  if (!!file) {
    formData.append('file', file);
  }

  return formData;
};

export const submitDecisionRegistryEntry = (props: {
  employeeId: number;
  decisionId?: number;
  data: FormData;
  customData?: object;
}) => {
  const { data: formData, customData, decisionId, employeeId } = props;

  const isEdit = !!decisionId;

  const url = `/form/employee/${employeeId}/decisionregistry/${
    isEdit ? `${decisionId}/update` : 'add'
  }`;

  return fetchFromOldApi(url, {
    method: isEdit ? 'PUT' : 'POST',
    body: formData,
  })
    .then((r) => r.json())
    .then((data) => {
      if (!customData) {
        return Promise.resolve(data);
      }

      const dataResponse = data as Response & { id: string };

      return fetchFromOldApi(
        `/json/customdata/DECISION_REGISTRY/${dataResponse.id}`,
        {
          method: 'PUT',
          body: JSON.stringify(customData) as BodyInit,
          headers: { 'Content-Type': 'application/json' },
        },
      );
    });
};
